export { default } from './Allergens';
